"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indentable = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function indentable(options) {
    var _a = options.indent, indent = _a === void 0 ? 20 : _a, relations = options.relations, targetColumnKey = options.targetColumnKey;
    return {
        getInfo: function () { return ({ name: "indentable" }); },
        onInjectColumn: function (previous) { return function (record, rowKey, recordIndex, column, columnIndex) {
            // 不是目标列
            if (!targetColumnKey || column.key !== targetColumnKey) {
                return previous(record, rowKey, recordIndex, column, columnIndex);
            }
            var _a = previous(record, rowKey, recordIndex, column, columnIndex), preChildren = _a.children, props = _a.props, result = tslib_1.__rest(_a, ["children", "props"]);
            var children = preChildren;
            // 非表头
            if (recordIndex !== -1) {
                var paddingLeft = 0;
                var depth = 0;
                if (indent > 0) {
                    var node = rowKey;
                    while (relations && relations[node]) {
                        depth += 1;
                        node = relations[node];
                    }
                    paddingLeft = indent * depth;
                }
                children = react_1.default.createElement("div", { style: { paddingLeft: paddingLeft } }, children);
            }
            return tslib_1.__assign(tslib_1.__assign({}, result), { props: props, children: children });
        }; },
    };
}
exports.indentable = indentable;
//# sourceMappingURL=indentable.js.map